import IKYU from './ikyu.json'
import PPG from './ppg.json'

export const SCENE = import.meta.env.VITE_MODE === 'ppg' ? PPG : IKYU
